import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Chip,
} from '@mui/material';

export default function RankContinuityPanel({ payload }) {
  const journeys = payload?.journeys || [];
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
        <Chip size="small" label={`Issue group: ${payload?.issue_group || '—'}`} />
        <Chip size="small" label={`Sampled: ${payload?.sampled_journey_count ?? journeys.length}`} />
        <Chip size="small" label={`Total with same issue: ${payload?.total_journeys_with_same_issue ?? '—'}`} />
      </Box>
      {journeys.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No sampled journeys.</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Journey</TableCell>
              <TableCell>Products</TableCell>
              <TableCell>Missing ranks</TableCell>
              <TableCell>Duplicates</TableCell>
              <TableCell>Reasons</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {journeys.map((j, idx) => (
              <TableRow key={`${j.journey}-${idx}`}>
                <TableCell>{j.journey}</TableCell>
                <TableCell>{j.total_products}</TableCell>
                <TableCell>{Array.isArray(j.missing_ranks) ? j.missing_ranks.join(', ') : '—'}</TableCell>
                <TableCell>{Array.isArray(j.duplicated_rank_values) ? j.duplicated_rank_values.join(', ') : '—'}</TableCell>
                <TableCell>{j.rank_reasons || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
